import { Component, ElementRef, OnInit } from '@angular/core';
import { NavigationEnd, NavigationError, Router } from '@angular/router';
import { Subject, fromEvent } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';
import { AppSettings } from './modules/shared/app.settings';
import { NotificationsService } from './modules/shared/services/notifications.service';
import { UserCommonService } from './modules/shared/services/user-common.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {

  showHeaderAndSidebar = false;
  isMetadataLoaded: any = false;
  private destroy$ = new Subject<void>();
  private fixPosition = 0;
  private toolbarWrap: HTMLElement | null = null;
  private toolbar: HTMLElement | null = null;
  private editor: HTMLElement | null = null;

  constructor(
    private router: Router,
    public notificationService: NotificationsService,
    public userCommonService: UserCommonService,
    private elementRef: ElementRef
  ) {
    this.router.events.subscribe((url: any) => {
      if (url.url !== undefined && url.url !== null) {
        const browserUrl = url.url.split('?');
        if (AppSettings.HEADER_NOT_REQUIRED.includes(browserUrl[0])) {
          this.showHeaderAndSidebar = false;
        } else {
          this.showHeaderAndSidebar = true;
        }
      }
    });

    this.router.events.subscribe((evt: any) => {
      if (evt instanceof NavigationError) {
        const message = evt?.error?.message || '';
        const isChunkError = message.includes('ChunkLoadError') || message.includes('Loading chunk');
        if (isChunkError) {
          const key = 'mi_chunk_reload_once';
          if (!sessionStorage.getItem(key)) {
            sessionStorage.setItem(key, '1');
            location.reload();
          } else {
            sessionStorage.removeItem(key);
          }
        }
      }
    });
  }

  ngOnInit() {
    sessionStorage.removeItem('mi_chunk_reload_once');
    this.toolbarWrap = this.elementRef.nativeElement.querySelector('#toolbar-wrap');
    this.toolbar = this.elementRef.nativeElement.querySelector('#toolbar');
    this.editor = this.elementRef.nativeElement.querySelector('#editor');

    this.userCommonService.scrollSectionToTop.subscribe(result => {
      if (result) {
        this.onActivate();
      }
    });

    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0)
    });
  }

  onActivate(event?: any) {
    const contentSection = document.getElementById('rightPanel');
    contentSection.scroll(0, 0);
  }

  ngAfterViewInit() {
    this.setupEventListeners();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private setupEventListeners() {
    if (this.editor) {
      fromEvent(this.editor, 'blur')
        .pipe(
          debounceTime(150),
          takeUntil(this.destroy$)
        )
        .subscribe(() => this.showToolbar());
    }

    fromEvent(window, 'scroll')
      .pipe(
        debounceTime(150),
        takeUntil(this.destroy$)
      )
      .subscribe(() => this.showToolbar());
  }

  private showToolbar() {
    if (this.fixPosition > 0 && this.toolbar) {
      this.toolbar.classList.remove('down');
      this.fixPosition = 0;
      this.toolbar.style.marginTop = '0px';
    }

    this.setMargin();
  }

  private setMargin() {
    if (this.toolbarWrap) {
      const newPosition = this.toolbarWrap.getBoundingClientRect().top;

      if (newPosition < -1) {
        this.toolbar?.classList.add('down');
        this.fixPosition = Math.abs(newPosition) - ((window.innerHeight + window.scrollY) >= document.body.offsetHeight ? 2 : 0);
        this.toolbar.style.marginTop = this.fixPosition + 'px';
      }
    }
  }

  loadUI() {
    let isLoaded: boolean;
    let sideBar: boolean;
    let selectedMenu = sessionStorage.getItem('selectedDashboard');
    if (selectedMenu) {
      sideBar = true;
    }
    isLoaded = this.notificationService.canFetchNotification;
    return isLoaded;
  }
}